module.exports = __webpack_public_path__ + "img/KMS-J-10.ee01e3b1.svg";